<template>
    <!-- <NewsDetail v-if="info.visible" :info="info" @onChange="row=> info=row " /> -->
    <div class="page-wrapper" style="height:auto; background-image: linear-gradient(to bottom, #ebf8ff, #f5f7fa ); ">
        <div class="page-content" style="padding:100px 0 60px 0;">
            <div class="title" style="height:40px; line-height:56px; font-weight:lighter; margin-top:50px; margin-bottom:100px;">了解华翊最新动态</div>    
            <!-- 动态logo -->
            <div class="motion-icon"><img :src="Icon" /></div>
            <div class="tag-container" style="margin-bottom:30px;">
                <div
                    v-for="item in tagList"
                    :key="item"
                    :class="{ 'tag-item':true, 'selected':item === current }"
                    @click="current = item"
                >
                    {{ item }}
                </div>
            </div>   
            <div v-if="list.length" class="card-container" style="margin-bottom:46px; ">
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="card"
                    @click="$router.push( `/about/news-detail?id=${item.contentId}&page=${pageInfo.currentPage}&category=${current}`)"
                    style="width:calc( 33.3% - 16px )"
                >
                    <div class="card-image" :style="{ backgroundImage:`url(${getFullPathMethod(item.coverImagePath)})` }"></div>
                    <div class="card-content">
                        <div class="card-title">{{ item.tittle }}</div>
                        <div class="card-desc">{{  htmlToString(item.content) }}</div>
                        <div class="card-extra">
                            <div style="color:#99A0AE; font-size:16px; ">{{  item.createTime }}</div>
                            <div class="tag">{{ item.category }}</div>
                        </div>
                    </div>
                </div>
                 
            </div> 
            <div v-else class="card-container" style="margin-bottom:46px; ">
                <div class="empty-wrapper">
                    <img :src="emptyBg" />
                </div> 
            </div>
            <el-pagination 
                v-if="total > 9 "
                class="custom-pagination"
                :current-page="pageInfo.currentPage"
                :page-size="pageInfo.pageSize"
                :total="total"
                @current-change="handlePage" 
                background 
                layout="prev,pager,next" 
            />
        </div>
    </div>
</template>
<script>
    import { getFullPath, getContentList } from '@/api/global.js';
    import emptyBg from '@/assets/empty.png';
    import Icon from '@/assets/motion-icon.png';
    const tagList = ['全部', '华翊动态', '行业深度', '沙龙活动', '产品资讯'];
    const imgReg = /<img.*?>/g;
    const videoReg = /<video.*?(?:>|\/>)/gi;
    
    export default {
        data(){
            return {
                emptyBg,
                Icon,
                tagList,
                current:'全部',
                pageInfo:{ currentPage:1, pageSize:9 },
                total:0,
                info:{},
                list:[],
            }
        },
        methods:{
            getFullPathMethod(path){
                return getFullPath(path);
            },
            htmlToString(html){
                var tempDiv = document.createElement("div");
                  html = html.replace(imgReg, '');
                  html = html.replace(videoReg, '');
                tempDiv.innerHTML = html;
                return tempDiv.textContent || tempDiv.innerText || "";
            },
            fetchContentList(){
                let params = { page:this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize, contentType:'动态', category:this.current === '全部' ? '' : this.current }
                getContentList(params)
                .then(res=>{
                    if ( res.data.code === 200 ) {
                        this.list = res.data.data;
                        this.total = res.data.total;
                        // if ( this.$route.query.id ) {
                        //     let obj = res.data.data.filter(i=>i.contentId === Number(this.$route.query.id) )[0];
                        //     if ( obj ) {
                        //         this.info = { ...obj, visible:true };
                        //     }
                        // }
                    }
                })
            },
            handlePage(page){
                this.pageInfo = { ...this.pageInfo, currentPage:page }
            }
        },
        watch:{
            current(){
                this.pageInfo = { ...this.pageInfo, currentPage:1 };
            },
            pageInfo(){
                this.fetchContentList();
            },
        
        },
        mounted(){
            this.fetchContentList();
        }
    }

</script>
<style>
    .tag-container {
        display:flex;
        justify-content: center;
    }
    .tag-container .tag-item {
        padding:10px;
        border: 1px solid #e1e4ea;
        border-radius:26px;
        box-shadow: 0px 1px 2px #0a0d1408;
        background:transparent;
        font-size:14px;
        color:#99A0AE;
        transition: all 0.3s ease-in;
        margin-right:26px;
        cursor: pointer;
    }
    .tag-container .tag-item:last-child {
        margin-right:0;
    }
    .tag-container .tag-item:hover {
        border-color:transparent;
        color:#000;
    }
    .tag-container .tag-item.selected {
        border: 1px solid #335cff;
        background:#fff;
        color:#335cff;
    }
    .tag-container .tag-item.selected:hover {
        border-color:transparent;
        background:#dfe8fd;
    }
    .card-container .card:hover {
        box-shadow:0 0 50px rgba(0,0,0,.05);
    }
    .motion-icon {
        position:absolute;
        top:100px;
        right:0;
        animation:move 5s infinite;
    }
    @keyframes move {
        0% {
            transform:translateY(0);
        }
        50% {
            transform:translateY(-50px);
        }
        100% {
            transform:translateY(0);
        }
    }
</style>